import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';

import './src/styles/global.css';
import './src/styles/forms.css';
import './src/styles/headings.css';
import './src/styles/pagination.css';
